import { useState, useEffect, useMemo, useRef, useCallback } from 'react'
import useAxios from 'axios-hooks'
import { isEqual, omit, pick } from 'lodash'
import { PROGRAM_SEARCH_DEFAULT_PARAMS } from 'utils/constants'
import { sanitizeParams } from 'utils/sanitizeParams'

export const useProgramSearch = (initialState = PROGRAM_SEARCH_DEFAULT_PARAMS) => {
  const [params, setParams] = useState()
  const paramsRef = useRef()

  const [
    { data, loading, error },
    execute,
  ] = useAxios({
    url: 'programs',
    method: 'POST',
    data: sanitizeParams(params)
  }, { manual: true })

  useEffect(() => {
    if (params && !isEqual(params, paramsRef.current)) {
      paramsRef.current = params
      execute()
    }
  }, [params])

  const setFilter = useCallback((values) => {
    setParams({ ...initialState, ...params, ...values })
  }, [setParams, initialState, params])

  const clearFilters = useCallback(() => {
    setParams({
      ...pick(params, 'sort', 'sortDirection'),
      ...pick(initialState, 'paginated', 'page', 'pageSize'),
    })
  }, [setParams, params, initialState])

  return useMemo(() => ({
    data,
    loading,
    error,
    params,
    setFilter,
    clearFilters,
  }), [
    data,
    loading,
    error,
    params,
    setFilter,
    clearFilters,
  ])
}
